<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "2022-09-11_otevoima";
    let title = "Otteen ja puristusvoiman vahvistaminen";
    let author = "Markus";
    let blogDate = "11.9.2022";
    let titlePic = "2022/FatGripzMave2.jpg";
    let firstPara = "Hyvästä puristusvoimasta on hyötyä niin kuntosalilla kuin kotitöissä. Lue tästä vinkit otevoiman kehittämiseen.";
</script>
<!--  Blogi koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>

            <p>Otevoima eli puristusvoima vahvistuu muun kuntosalitreenin lomassa kuin itsestään. Joskus se kuitenkin voi jäädä kehityksen pullonkaulaksi, 
                jolloin otevoiman treenaaminen erikseen on tarpeellista ja perusteltua. Kuntosalilla voi treenata monipuolisesti myös otevoimaa. 
                Eikä sen treenaaminen kotonakaan mahdotonta ole. Kaikki alkaa siitä, että ottaa ote-voimatreenit mukaan normaaliin
                treeniin.
            </p>
            <p>Erityisesti vapailla painoilla ja kehonpainolla harjoiteltaessa tarvittavan puristusvoiman merkitys korostuu.</p>
           
            <p>Jaan tässä kirjoituksessa otevoimatreenit vain kahteen kategoriaan yksinkertaisuuden vuoksi eli, peukalon
                vahvistamiseen ja sormien vahvistamiseen.
            </p>
            <p>Alla muutamia vinkkejä, miten voit parantaa puristus- ja otevoimaa. </p>
            <h3>Peukalon rooli otevoimassa</h3>
            <p>Monille tulee ehkä yllätyksenä, että otteen heikkous voi johtua ihan vain peukalon merkityksen
                unohtamisesta. Olenkin huomannut, että ihan ensimmäinen ohje vahvempaan otteeseen on peukalon
                merkityksestä muistuttaminen. Huomioi siis seuraavalla kerralla, että voit puristaa peukalollasi
                mahdollisesti sekä etu- että keskisormea paremmin tangon ympärille.
            </p>
            <h3>Voit toki tehdä otevoimaan pikaisen parannuksen eli peukalolukon.</h3>
            <p>Peukalolukossa peukalo puristetaan ensin tangon ympärille ja sen jälkeen sormet, lähinnä etusormi ja
                keskisormi, puristuu peukalon ja tangon ympärille. Voit avittaa otetta hieman “kurottamalla” peukalolla
                pidemmälle, jolloin peukalo ikään kuin siirtyy keskemmäksi kämmentä.
            </p>
            <p>Peukalolukko voi tuntua alkuun hieman epämiellyttävältä ja jopa kivuliaalta. Aluksi voi käyttää apuna
                hanskoja tai teipata peukalon esimerkiksi urheiluteipillä. Pikkuhiljaa peukalolukkoon tottuu, ja
                erityisesti painonnostoliikkeissä sen käytöstä muodostuu nopeasti automaatio.
            </p>
            <h3>Miten ote- tai puristusvoimaa treenataan?</h3>
            <p>Niin tylsältä kuin se tuntuukin, otevoimaa treenataan kuten mitä tahansa voimaa: säännöllisesti ja
                jatkuvasti kuormaa nostaen. Aluksi aloitetaan kevyesti, ettei otevoiman treenaamisella rasiteta lihaksia
                liikaa. Voimaa on hyvä säästää muuhunkin treenaamiseen. Treenit on nimittäin monesti todella vaikeita, jos
                ote pettää ja forkut on jumissa.
            </p>
            <p>Voit tehdä erilaisia otevoima harjoituksia esimerkiksi kaksi kolme kertaa viikossa aina treenin
                päätteeksi. Tee toistoja tai staattisia pitoja. Yksi työsarja voi kestää n. 10 - 30 sekuntia, jonka
                aikana ehdit ottamaan esimerkiksi erilaisissa nostoissa 3-10 toistoa.
            </p>
            <p>Voit yhdistellä yhteen otevoimatreeniin useampia harjoitteita. Yhdessä treenissä voi olla siis mukana
                sekä peukaloa , että sormia vahvistavia liikkeitä. Alkuun kannattaa kuitenkin muistaa maltti ja lähteä
                ehdottomasti liikkeelle kevyesti ja keskittyä vain joko peukalon tai sormien vahvistamiseen.
            </p>
            <h3>Peukalon vahvistaminen</h3>
            <p>Peukalo tuskin vahvistuu vain huomioimalla sen erilaisissa roikunnoissa tai maastavedossa, vaikka sen
                merkityksen ymmärtäminen saattaakin parantaa heti otettasi. Sen sijaan erittäin hyvä tapa vahvistaa
                peukaloa on tehdä erilaisia nostoja pinsettiotteella.
                Katso esimerkki alla olevasta kuvasta. Voit lisätä kuormaa käyttämällä paksumpia tai raskaampia levypainoja.
            </p>
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <img src='/svelte-site/img/blog/2022/Pinsettiote.png'
                        alt="Pinsettiote">
                </div>
            </div>

            <p>&nbsp;</p>
            <p>Salilta löytyy myös vähän spesiaalimpi aparaatti peukalon vahvistamiseen. Suosittelen kokeilemaan.</p>
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <img 
                         src='/svelte-site/img/blog/2022/Grippilaite2.jpg'
                         alt=""></div>
            </div>
            <h3>Sormien vahvistaminen</h3>
            <p>Sormia voi vahvistaa hyvin yksinkertaisilla liikkeillä, kuten roikkumalla apinaotteella. Eli otteella,
                jossa peukalo on sormien kanssa samalla puolella.
                Jos roikunta kahdella kädellä sujuu nätisti, voit siirtyä käyttämään yhtä kättä.
            </p>
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <img 
                         src='/svelte-site/img/blog/2022/Roikunta2.png'
                         alt="Roikunta apinaotteella kahdella kädellä"></div>
            </div>


            <p>Lisäksi sormien vahvistamisessa voi käyttää yhden käden maastavetoa ja ihan puristusvoiman
                parantamiseen tarkoitettuja FatGripzejä.</p>


            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <img 
                         src='/svelte-site/img/blog/2022/SinFatGripz1.jpg'
                         alt="FatGripz"></div>
            </div>
            <p>&nbsp;</p>

            <h3>Muista monipuolisuus ja progressiivisuus</h3>

            <p>Otevoimaa treenataan kuten kaikkea muutakin voimaa. Säännöllisesti
                tehtyinä harjoitteet kehittävät varmasti. Muista kuitenkin treeneissäsi
                progressiivisuus. Eli aloita kevyestä ja lisää kuormaa koko ajan.</p>
            <p>Monipuolisuutta treeniin saa vaihtelemalla esimerkiksi pinsettiotteen paksuutta, Fatgripzien
                paksuutta ja vaikka heittämällä treeniin mukaan taisteluköysipaiskailua ja farmarikävelyä.</p>
            
                <div class="row">
                <div class="col-xs-12 col-md-6">
                    <img src='/svelte-site/img/blog/2022/Farmarikavely1.jpg'
                         alt="Farmarikävely">
                </div>
                <div class="col-xs-12 col-md-6">
                    <img src='/svelte-site/img/blog/2022/Taistelukoydet.jpg'
                         alt="Taisteluköydet">
                </div>
            </div>
            <p>Vahvaa grippiä syksyyn!</p>
            <p> - Markus</p>
        </article>

        <section class="container">
            <h2>Lue seuraavaksi</h2>
            <div class="row">
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='muscle_up_renkaissa' title='Muscle up renkaissa' titlePic='2018/muscleup_strip.jpg' blogDate='' firstPara='Muscle up, jota myös voimavedoksi sanotaan, on liike jossa urheilija punnertaa itsensä roikkumisasennosta renkaiden päälle rengaspitoon. Tässä artikkelissa käymme läpi muutamia vinkkejä liikkeen opettelemiseksi.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='onko-sellaista-kun-liian-huono-kunto' title='Liian huono kunto?' titlePic='kahvakuulat-4-1500x630.jpg' blogDate='' firstPara='Kun olen kutsunut kiinnostuneita treenaajia piipahtamaan salille tutustumaan, olen usein törmännyt kommenttiin: täytyy ensin hieman treenata, ennen kuin uskaltaa tulla käymään.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='nuts-karhunkierros-2019-83km' title='Ensikertalaisena NUTS Karhunkierroksella' titlePic='karhunkierros.jpg' blogDate='' firstPara='Kaikki alkoi jostain tyhmästä ideasta, joka alkoi pikkuhiljaa paisua. Lähteä nyt juoksemaan Karhunkierros, oletko ikinä kokeillut vaeltaa sitä, no en ole. Ja nyt se oli edessä. 83 km, hirvitti.'></BlogSummary>
                </article>
            </div>
        </section>

    </div>
{/if}

<style>



</style>
